import { css } from 'styled-components';

export const setSvgColors = ({ fillColor, strokeColor }) => css`
  svg {
    background: ${fillColor};
    fill: ${fillColor};
    stroke: ${strokeColor};
  }
`;
